var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClockWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "15px",
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "clock") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Main-screens-Stage-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "photo-preview-big",
    transform: "translate(-108.000000, -755.000000)",
    stroke: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "clock",
    transform: "translate(108.000000, 755.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 7.5,
    cy: 7.5,
    r: 6.8125
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "7.5 3.125 7.5 8.125 11.5625 8.125"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockWhite);
export default __webpack_public_path__ + "static/media/clockWhite.b0c9a736b56e617962e477c0627dcbdd.svg";
export { ForwardRef as ReactComponent };